import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../../Constants";
import { Search, CheckCircle, CheckBoxOutlineBlank } from "@mui/icons-material";

// Any other imports you need:
import SingleStepScrape from "./SingleStepScrape/SingleStepScrape";

// You no longer need a <Dialog> for DirectorList
// since we’ll display it in the parent panel instead.

const ScrapingForm = ({ onScrapeSuccess, onOpenDirectorList }) => {
  const [directors, setDirectors] = useState([]);
  const [ticket, setTicket] = useState({
    directors: [],
    startDate: "",
    endDate: "",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    fetchDirectors();
    // eslint-disable-next-line
  }, []);

  const fetchDirectors = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/setup/dobconnectdirectors/all`, {
        method: "GET",
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setDirectors(data);
    } catch (err) {
      console.error("Error fetching directors:", err);
      setError("Failed to fetch directors. Please try again later.");
    }
  };

  const handleDirectorSelection = (director) => {
    const isSelected = ticket.directors.some((d) => d.id === director.id);
    const updatedDirectors = isSelected
      ? ticket.directors.filter((d) => d.id !== director.id)
      : [...ticket.directors, { id: director.id, email: director.email }];
    setTicket({ ...ticket, directors: updatedDirectors });
  };

  return (
    <div className="flex flex-col items-center bg-gray-100 rounded-t-3xl border gap-6 overflow-y-auto h-screen"
         style={{ paddingBottom: "40px" }}>
      {/* Directors Box */}
      <div className="w-11/12 max-w-md p-6 mt-6 bg-white rounded-lg shadow-md border space-y-4 relative">
        <div className="flex items-center justify-between pb-2 border-b border-gray-300">
          <h2 className="text-lg font-bold text-gray-700">Directors</h2>
          {/* Use the search icon button to show the DirectorList in the right panel */}
          <button
            onClick={onOpenDirectorList}
            className="px-2 py-1 text-white bg-blue-600 rounded hover:bg-blue-500 focus:outline-none"
            title="Search Directors"
          >
            <Search />
          </button>
        </div>

        {/* Directors listing with checkboxes (for immediate selection) */}
        <div className="border-2 border-gray-300 rounded-lg shadow-md bg-white w-full">
          <div className="flex items-center py-2 border-b bg-gray-200 rounded-t-lg px-2 w-full">
            <div className="w-1/2 font-bold text-sm text-gray-700">Name</div>
            <div className="w-1/2 font-bold text-sm text-gray-700 text-center">
              Select
            </div>
          </div>
          <div className="max-h-32 overflow-auto w-full">
            {directors.map((d) => {
              const isSelected = ticket.directors.some((dir) => dir.id === d.id);
              return (
                <div
                  key={d.id}
                  className="flex items-center py-2 border-b last:border-b-0 hover:bg-gray-100 cursor-pointer px-2 w-full"
                  onClick={() => handleDirectorSelection(d)}
                >
                  <div className="w-1/2 text-sm text-gray-700">{d.name}</div>
                  <div className="w-1/2 flex justify-center">
                    {isSelected ? (
                      <CheckCircle fontSize="small" className="text-green-500" />
                    ) : (
                      <CheckBoxOutlineBlank fontSize="small" className="text-gray-500" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Single-Step Scrape card */}
      <div className="w-11/12 max-w-md p-6 border-2 border-gray-300 rounded-lg shadow-md bg-white space-y-6">
        <SingleStepScrape
          selectedDirectors={ticket.directors}
          startDate={ticket.startDate}
          setStartDate={(val) => setTicket({ ...ticket, startDate: val })}
          endDate={ticket.endDate}
          setEndDate={(val) => setTicket({ ...ticket, endDate: val })}
        />
      </div>

      {/* Error alert if needed */}
      {error && (
        <div className="fixed bottom-4 right-4 bg-red-500 text-white px-4 py-2 rounded shadow-lg">
          {error}
        </div>
      )}
    </div>
  );
};

export default ScrapingForm;
